import { c as _c } from "react/compiler-runtime";
export default function ArrowRightEcon(t0) {
  const $ = _c(3);
  const {
    className
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path d="M11.18.211c3.506 2.728 6.192 5.342 7.982 7.767.451.608.452 1.43 0 2.044-1.792 2.426-4.478 5.04-7.983 7.767a1 1 0 01-1.403-.175.993.993 0 01-.21-.613 1 1 0 01.385-.79c2.795-2.175 5.034-4.258 6.677-6.207H1.499a1 1 0 110-2h15.135c-1.642-1.951-3.884-4.036-6.682-6.215A1 1 0 1111.18.211z" fillRule="evenodd" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== className) {
    t2 = <svg aria-hidden={true} className={className} fill="currentColor" height="18" viewBox="0 0 20 18" width="20" xmlns="http://www.w3.org/2000/svg">{t1}</svg>;
    $[1] = className;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}